export function isPositiveNumber(value: string) {
  const n = Number(value);
  return !Number.isNaN(n) && n > 0;
}

export interface SizeConstraints {
  minWidth: number;
  maxWidth: number;
  minHeight: number;
  maxHeight: number;
}

export function getDimensionError(w: number, h: number, constraints: SizeConstraints) {
  const { minWidth, maxWidth, minHeight, maxHeight } = constraints;
  const minDim = Math.min(minWidth, minHeight);
  if (w < minDim || h < minDim) {
    return `Each side must be at least ${minDim}"`;
  }
  const fitsNormal = w <= maxWidth && h <= maxHeight;
  const fitsRotated = w <= maxHeight && h <= maxWidth;
  if (!fitsNormal && !fitsRotated) {
    return `Dimensions must fit within ${Math.min(maxWidth, maxHeight)}" \u00d7 ${Math.max(maxWidth, maxHeight)}"`;
  }
  return undefined;
}
